/**
 * Save Holidays By Company Schema
 *
 * Zod validation schema for saving holidays by company
 */

import { z } from "zod";

/**
 * Schema for saving holidays by company
 */
export const saveHolidaysByCompanyArgsSchema = z.object({
  title: z.string().min(1, "Título é obrigatório"),
  dates: z.array(z.string()).min(1, "Pelo menos uma data é obrigatória"),
  company: z.object({
    id: z.number().positive("ID da empresa deve ser positivo")
  })
});
